import { createContext } from "react";
import IBaseListingResponse from "../../../utils/api/base-listing-response";
import {
  DEFAULT_FUNCTION,
  DEFAULT_QUERY,
} from "../../../utils/helpers/constants";
import { IClient, IClientDetails } from "../../../models/client/response";
import { IClientQuery } from "../../../models/client/query";
import { ICreateClient, IUpdateClient } from "../../../models/client/request";
import { IDiscountCode } from "../../../models/discount-code/response";

export type ClientLoading = "list" | "details" | "create" | "update" | "delete";

export interface IInternalState {
  loading: ClientLoading[];
  listClientPoints?: IBaseListingResponse<any>;
  query: IClientQuery;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
 
    getListClientPoints: (id: number) => void;
 
    setSearch: (search?: string) => void;
    setQuery: (query: IClientQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
   
    getListClientPoints: DEFAULT_FUNCTION,
  

    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const ClientPointsContext = createContext(externalState);

export default ClientPointsContext;
